import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ResourceGridMatrixtyles = makeStyles((theme) => ({
  container: { padding: 25, margin: "0" },
  header: { marginBottom: 10 },
  subHeader: {
    marginBottom: 35,
    color: COLORS.DARK_GRAY_2
  },
  cardBlock: { padding: 30 },
  cardContainer: {
    boxShadow: "0px 2.70968px 13.5484px rgba(40, 73, 147, 0.15)",
    borderRadius: 7,
    padding: 26
  },
  cardLink: { textDecoration: "none" },
  cardHeaderContainer: {
    display: "flex",
    alignItems: "center",
    color: COLORS.PRIMARY
  },
  iconFontSize: {
    fontSize: 30,
    float: "right",
    color: COLORS.DARK_GRAY
  }
}));

export default ResourceGridMatrixtyles;
